<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Accelerating onboarding times without burdening clients</h2>
    <p>Due to the challenges around private company data collection, On-boarding processes are an inefficient and time-intensive bottleneck for Africa-focused banks. Asoko provides data and document collection services to enable banks with faster access to official data on new and existing corporate clients.</p>
    <div class="action-wrap">
      <a @click="openSolutions" class="cta-button" :class="colorMode === 'light' ? 'medium-button' : ''">Read More</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bank-relationship-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openSolutions() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Bank Relationship Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Bank Relationship Block',
      })
      this.$router.push({ name: 'solutions-page' })
    },
  },
}
</script>
